/* eslint-disable @typescript-eslint/no-empty-interface, @typescript-eslint/no-misused-promises */
/* eslint-disable max-len, react/function-component-definition */
/* eslint-disable class-methods-use-this */
import React, { Component } from 'react';
import { Button } from '@mui/material';
import DocViewer, { DocViewerRenderers } from '@cyntler/react-doc-viewer';
import { connect, ConnectedProps } from 'react-redux';
import { getContentType } from 'src/components/elements/File/utils';
import { confirmWrapper } from 'src/components/Dialog';
import { DialogContentProps } from 'src/components/Dialog/Dialog';
import PlayServiceRequests from 'src/network/playServices';
import { FileValueType } from 'src/components/elements/File';
import { AppRootState } from 'src/store';
import { updateTab } from 'src/store/jobRequisitionTabs';
import { TabInfo } from 'src/components/MultiTab';
import CandidateDetailsForm, { CandidateDetailsFormValues } from './components/CandidateDetailsForm';
import withRouter from '../../hooks/withRouter';
import API from '../../network';
import {
  ViewJobProps,
  ViewJobState,
  ViewJobViewRendererProps,
  UpdateJobDescription,
  UpdateOthersTab,
  UpdateJobLocation,
  UpdateSkills,
  UpdateRecruiters,
  UpdateJobDetails,
} from './types';
import ViewRenderer from './views';
import { tabsList } from './constants';

interface PopupProps extends DialogContentProps {
  oldResponse: any;
  jobId: string;
  jobTitle: string;
  email: string;
  fileName: string | null;
  useNewResume: (props: { confirmationPopupClose: (() => void) | undefined; res?: any }) => void;
  candidateDetailsFormData: CandidateDetailsFormValues;
}

const Popup = (props: PopupProps) => {
  const {
    useNewResume,
    oldResponse,
    close,
    jobId,
    jobTitle,
    email,
    fileName,
    candidateDetailsFormData,
  } = props;

  return (
    <div className="p-4 pt-6 h-[230px]">
      <div className="mb-4 text-center text-lg font-semibold">
        {'Apply to '}
        {jobId}
        {' - '}
        {jobTitle}
      </div>
      <div className="mb-4 text-center text-sm font-semibold">
        {'Resume: '}
        {fileName}
      </div>
      <div className="mb-4 text-center text-xs">
        Resume with email (
        {email}
        ) already exists.
      </div>
      <div className="mt-8 flex justify-evenly items-center">
        <Button
          type="submit"
          variant="contained"
          size="small"
          onClick={() => {
            if (close) close();
            useNewResume({ confirmationPopupClose: close, res: candidateDetailsFormData });
          }}
        >
          {
            fileName ? 'UPDATE WITH NEW RESUME' : 'UPDATE WITHOUT RESUME'
          }
        </Button>
        <Button
          type="submit"
          variant="outlined"
          size="small"
          onClick={() => {
            if (close) close();
            useNewResume({ confirmationPopupClose: close, res: oldResponse });
          }}
        >
          USE EXISTING RESUME
        </Button>
      </div>
    </div>
  );
};

type ViewJobPropsWithRedux = ViewJobProps & ConnectedProps<typeof connector>;
class ViewJob extends Component<ViewJobPropsWithRedux, ViewJobState> {
  constructor(props: ViewJobPropsWithRedux) {
    super(props);

    this.state = {
      fetchingJobDetails: true,
      loading: false,
      jobDetails: {},
      candidatesLoading: false,
      candidatesList: [],
      matchingResumeList: [],
      payTypes: [],
      workAuthorizations: [],
      resumeSources: [],
      parseResponse: {},
      candidateDetailsFormData: {},
      updateResume: false,
      fileName: null,
      useNewResume: false,
      assignedToAll: false,
      checkDuplicate: null,
      tabValue: tabsList.appliedResume,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.fetchJobDetails();
    this.getCandidatesForJob();

    this.getAllPayTypes();
    this.getAllWorkAuthorizations();
    this.getAllResumeSources();
  }

  componentDidUpdate(prevProps: ViewJobProps) {
    const { router: prevRouter } = prevProps;
    const { id: prevJobOrderId } = prevRouter?.params ?? {};

    const { router } = this.props;
    const { id: jobOrderId } = router?.params ?? {};

    if (prevJobOrderId !== jobOrderId) {
      this.fetchJobDetails();
      this.getCandidatesForJob();
      this.setState({
        assignedToAll: false,
        tabValue: tabsList.appliedResume,
      });
    }
  }

  setAssignedToAll = (data: boolean) => {
    this.setState({
      assignedToAll: data,
    });
  };

  fetchJobDetails = async () => {
    this.setState({
      loading: true,
      fetchingJobDetails: true,
    });
    const { router, reduxProps, updateReduxTab } = this.props;
    const { navigate } = router;
    const { id: jobOrderId } = router?.params ?? {};
    const { jobRequisitionTabs } = reduxProps;

    try {
      const response: any = await API.getInstance().fetchJobDetails(jobOrderId || '');
      this.setState({
        jobDetails: response,
      });
      const alreadyExists = jobRequisitionTabs.find((item) => item.jobOrderId === Number(jobOrderId));
      if (!alreadyExists) {
        updateReduxTab({
          label: response.jobId,
          to: `/job-requisition/view-job/${jobOrderId}`,
          closeable: true,
          jobId: response.jobId,
          jobOrderId,
        });
      }
    } catch (e) {
      await confirmWrapper('Something went wrong', {
        hideSecondaryBtn: true,
        variant: 'danger',
      });
      navigate('/job-requisition/job-list');
    } finally {
      this.setState({
        loading: false,
        fetchingJobDetails: false,
      });
    }
  };

  handleChangeTabValue = (val: string) => {
    this.setState({
      tabValue: val,
    });
  };

  getCandidatesForJob = async (assignedToAll: boolean = false) => {
    this.setState({
      candidatesLoading: true,
    });
    const { router } = this.props;
    const { id: jobOrderId } = router?.params ?? {};

    try {
      if (!assignedToAll) {
        const response: any = await API.getInstance().getCandidatesOfRecruiter(jobOrderId || '');
        this.setState({
          candidatesList: response,
        });
      } else {
        const response: any = await API.getInstance().getAllCandidatesForJob(jobOrderId || '');
        this.setState({
          candidatesList: response,
        });
      }
    } catch (e) {
      await confirmWrapper('Something went wrong', {
        hideSecondaryBtn: true,
        variant: 'danger',
      });
    } finally {
      this.setState({
        candidatesLoading: false,
      });
    }
  };

  getMatchingResumes = async () => {
    this.setState({
      candidatesLoading: true,
    });
    const { router } = this.props;
    const { id: jobOrderId } = router?.params ?? {};
    try {
      const response = await API.getInstance().getMatchingResumes(jobOrderId || '');
      this.setState({
        matchingResumeList: response,
      });
    } catch (e) {
      await confirmWrapper('Something went wrong', {
        hideSecondaryBtn: true,
        variant: 'danger',
      });
    } finally {
      this.setState({
        candidatesLoading: false,
      });
    }
  };

  updateJobDetails = async (request: UpdateJobDetails, type: string) => {
    this.setState({
      loading: true,
    });

    try {
      await API.getInstance().updateJobDetails(request);
      await confirmWrapper(`${type} updated successfully`, {
        hideSecondaryBtn: true,
        hidePrimaryBtn: true,
        variant: 'success',
        autoClose: true,
      });
    } catch (e) {
      await confirmWrapper('Something went wrong', {
        hideSecondaryBtn: true,
        variant: 'danger',
      });
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  updateOthersTab = async (request: UpdateOthersTab, type: string) => {
    this.setState({
      loading: true,
    });

    try {
      await API.getInstance().updateOthersTab(request);
      await confirmWrapper(`${type} updated successfully`, {
        hideSecondaryBtn: true,
        hidePrimaryBtn: true,
        variant: 'success',
        autoClose: true,
      });
    } catch (e) {
      await confirmWrapper('Something went wrong', {
        hideSecondaryBtn: true,
        variant: 'danger',
      });
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  updateJobLocations = async (request: UpdateJobLocation) => {
    this.setState({
      loading: true,
    });

    try {
      await API.getInstance().updateJobLocations(request);
      await confirmWrapper('Job Locations updated successfully', {
        hideSecondaryBtn: true,
        hidePrimaryBtn: true,
        variant: 'success',
        autoClose: true,
      });
    } catch (e) {
      await confirmWrapper('Something went wrong', {
        hideSecondaryBtn: true,
        variant: 'danger',
      });
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  updateSkills = async (request: UpdateSkills) => {
    this.setState({
      loading: true,
    });

    try {
      await API.getInstance().updateSkills(request);
      await confirmWrapper('Skills updated successfully', {
        hideSecondaryBtn: true,
        hidePrimaryBtn: true,
        variant: 'success',
        autoClose: true,
      });
    } catch (e) {
      await confirmWrapper('Something went wrong', {
        hideSecondaryBtn: true,
        variant: 'danger',
      });
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  updateJobDescription = async (request: UpdateJobDescription) => {
    this.setState({
      loading: true,
    });

    try {
      await API.getInstance().updateJobDescription(request);
      await confirmWrapper('Job Description updated successfully', {
        hideSecondaryBtn: true,
        hidePrimaryBtn: true,
        variant: 'success',
        autoClose: true,
      });
    } catch (e) {
      await confirmWrapper('Something went wrong', {
        hideSecondaryBtn: true,
        variant: 'danger',
      });
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  updateJobRecruiters = async (request: UpdateRecruiters) => {
    this.setState({
      loading: true,
    });

    try {
      await API.getInstance().updateJobRecruiters(request);
      await confirmWrapper('Job Recruiters updated successfully', {
        hideSecondaryBtn: true,
        hidePrimaryBtn: true,
        variant: 'success',
        autoClose: true,
      });
    } catch (e) {
      await confirmWrapper('Something went wrong', {
        hideSecondaryBtn: true,
        variant: 'danger',
      });
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  addJobNotes = async (request: any) => {
    this.setState({
      loading: true,
    });

    try {
      const newNote = await API.getInstance().addJobNotes(request);
      this.setState((prevState) => ({
        ...prevState,
        jobDetails: {
          ...prevState?.jobDetails,
          notes: [
            ...((prevState && prevState?.jobDetails && prevState?.jobDetails?.notes) || []),
            newNote,
          ],
        },
      }));
      await confirmWrapper('Note added successfully', {
        hideSecondaryBtn: true,
        hidePrimaryBtn: true,
        variant: 'success',
        autoClose: true,
      });
    } catch (e) {
      await confirmWrapper('Something went wrong', {
        hideSecondaryBtn: true,
        variant: 'danger',
      });
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  updateJobNotes = async (request: any, id: number) => {
    this.setState({
      loading: true,
    });

    try {
      const editedNote = await API.getInstance().updateJobNotes(request, id);

      const { jobDetails } = this.state;
      const { notes } = jobDetails || {};
      const index = (notes || []).findIndex((note: any) => note.id === id);
      notes.splice(index, 1, editedNote);
      this.setState((prevState) => ({
        ...prevState,
        jobDetails: {
          ...prevState?.jobDetails,
          notes,
        },
      }));
      await confirmWrapper('Note updated successfully', {
        hideSecondaryBtn: true,
        hidePrimaryBtn: true,
        variant: 'success',
        autoClose: true,
      });
    } catch (e) {
      await confirmWrapper('Something went wrong', {
        hideSecondaryBtn: true,
        variant: 'danger',
      });
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  prepareSaveRequestObj = (data: any) => {
    const {
      parseResponse,
      updateResume,
      checkDuplicate,
    } = this.state;
    const { router } = this.props;
    const { id } = router?.params ?? {};
    const { candidateId } = (checkDuplicate && checkDuplicate[0]) || '';

    const request = {
      firstName: data?.firstName,
      lastName: data?.lastName,
      middleName: '',
      phoneNumber: data?.phoneNumber,
      emailAddress: data?.emailAddress,
      alternateEmail: data?.alternateEmail,
      candidateLocation: data?.candidateLocation,
      dateOfBirth: data?.dateOfBirth,
      experienceLevel: data?.experienceLevel,
      candidateTitle: data?.candidateTitle,
      payType: data?.payType,
      payRate: data?.payRate,
      currency: data?.currency,
      consultancyId: data?.consultancyId,
      consultancyContactId: data?.consultancyContactId,
      consultancyPhoneNumber: data?.consultancyPhoneNumber,
      extensionNumber: data?.extensionNumber,
      consultancyEmailAddress: data?.consultancyEmailAddress,
      reLocation: data?.reLocation,
      visaStatus: data?.visaStatus,
      resumeSource: data?.resumeSource,
      socialLinks: data?.socialLinks,
      fileURL: parseResponse?.s3DownloadLink || parseResponse?.fileURL,
      resumeHtmlUrl: parseResponse?.s3HtmlLink || parseResponse?.resumeHtmlUrl,
      candidateStatus: 'ADDED',
      updateResume,
      jdScore: data?.jdScore,
      comments: undefined,
      candidateJobMappings: [{
        jobOrderId: id,
      }],
      candidateComments: [{
        jobOrderId: id,
        comments: data?.comments,
      }],
      candidateJobResumeScore: [],
      jobOrderId: id,
      ...(candidateId && { candidateId }),
    };
    return request;
  };

  onSaveAndApply = async (request: any, close: (() => void) | undefined) => {
    const { assignedToAll } = this.state;
    try {
      this.setState({
        loading: true,
      });
      const res = await API.getInstance().onCandidateDetailsSave(request);
      const isAlreadyExists = res?.message.includes('already added');
      await this.getCandidatesForJob(assignedToAll);

      confirmWrapper(isAlreadyExists ? res?.message : 'Candidate Added successfully.', {
        variant: 'success',
        autoClose: !(isAlreadyExists),
        primaryBtnLabel: 'ok',
        hideSecondaryBtn: true,
      });
      this.setState({ useNewResume: false });
    } catch (e) {
      await confirmWrapper('Something went wrong', {
        hideSecondaryBtn: true,
        variant: 'danger',
      });
    } finally {
      this.setState({
        loading: false,
      });
      if (close) close();
    }
  };

  showPopup = async (data: any) => {
    const {
      payTypes,
      workAuthorizations,
      resumeSources,
      jobDetails,
      fileName,
      useNewResume,
      updateResume,
    } = this.state;

    const trimCountryCodes = (number: string | undefined) => {
      if (number) {
        if (number.startsWith('+91 ')) {
          return number.replace('+91 ', '').trim();
        }
        if (number.startsWith('+1 ')) {
          return number.replace('+1 ', '').trim();
        }
        const plainNumber = number.replace(/\D/g, '');
        return plainNumber.length === 10 ? plainNumber : null;
      }
      return null;
    };

    const resumeData = {
      ...data,
      phoneNumber: trimCountryCodes(data?.phoneNumber),
      comments: data?.candidateComments && data?.candidateComments.length > 0 ? data.candidateComments[0].comments : '',
    };

    await confirmWrapper('', {
      variant: '',
      hidePrimaryBtn: true,
      hideSecondaryBtn: true,
      maxWidth: 'md',
      fullWidth: true,
      showCloseButton: true,
      containerClasses: 'p-0',
      disableBackdropClickClose: true,
      disableEscapeKeyDownClose: true,
      dialogContent:
  <CandidateDetailsForm
    onSave={async (savedata, close) => {
      const request = this.prepareSaveRequestObj(savedata);
      await this.onSaveAndApply(request, close);
    }}
    resumeInfo={resumeData}
    payTypes={payTypes}
    workAuthorizations={workAuthorizations}
    resumeSources={resumeSources}
    jobDetails={jobDetails}
    fileName={fileName}
    handleEmailDuplicate={this.handleEmailDuplicate}
    useNewResume={useNewResume}
    onClose={this.onClose}
    updateResume={updateResume}
  />,
    });
  };

  onClose = () => {
    this.setState({ useNewResume: false });
  };

  showCandidateDetailsForm = async (file: FileValueType, withResume: boolean) => {
    const { jobDetails } = this.state;
    this.setState({
      loading: true,
      updateResume: false,
      useNewResume: false,
      checkDuplicate: null,
    }, async () => {
      try {
        if (file === null && withResume) return;

        if (file) {
          const formData = new FormData();
          formData.append('file', file ? file as File : '');
          formData.append('s3FolderName', 'PANNA');
          formData.append('userId', jobDetails?.createdBy);
          formData.append('fileExtension', (file as File)?.type || '');
          const response = await PlayServiceRequests.getInstance().resumeParser(formData);
          this.setState({ parseResponse: response, fileName: (file as File)?.name || '' }, () => {
            this.showPopup(response);
          });
        } else {
          this.setState({ parseResponse: null, fileName: null }, () => {
            this.showPopup(null);
          });
        }
      } catch (e) {
        await confirmWrapper('Something went wrong', {
          hideSecondaryBtn: true,
          variant: 'danger',
        });
      } finally {
        this.setState({
          loading: false,
        });
      }
    });
  };

  getAllPayTypes = async () => {
    // this.setState({
    //   loading: true,
    // });
    try {
      const payTypesResponse: any = await API.getInstance().getAllPaytypes();
      this.setState({
        payTypes: payTypesResponse,
      });
    } catch (e) {
      // await confirmWrapper('Something went wrong', {
      //   hideSecondaryBtn: true,
      //   variant: 'danger',
      // });
    } finally {
      // this.setState({
      //   loading: false,
      // });
    }
  };

  getAllWorkAuthorizations = async () => {
    // this.setState({
    //   loading: true,
    // });
    try {
      const workAuthorizationsResponse: any = await API.getInstance().getAllWorkAuthorizations();
      this.setState({
        workAuthorizations: workAuthorizationsResponse,
      });
    } catch (e) {
      // await confirmWrapper('Something went wrong', {
      //   hideSecondaryBtn: true,
      //   variant: 'danger',
      // });
    } finally {
      // this.setState({
      //   loading: false,
      // });
    }
  };

  getAllResumeSources = async () => {
    // this.setState({
    //   loading: true,
    // });
    try {
      const resumeSourcesRes: any = await API.getInstance().getAllResumeSources();
      this.setState({
        resumeSources: resumeSourcesRes,
      });
    } catch (e) {
      // await confirmWrapper('Something went wrong', {
      //   hideSecondaryBtn: true,
      //   variant: 'danger',
      // });
    } finally {
      // this.setState({
      //   loading: false,
      // });
    }
  };

  handleEmailDuplicate = async (email: string, checkDuplicate: any, formData: CandidateDetailsFormValues, close: (() => void) | undefined) => {
    try {
      this.setState({
        checkDuplicate,
        candidateDetailsFormData: formData,
      });
      if (checkDuplicate && checkDuplicate.length > 0) {
        const { jobDetails, fileName } = this.state;
        // if (close) close();
        await confirmWrapper('', {
          variant: '',
          hidePrimaryBtn: true,
          hideSecondaryBtn: true,
          maxWidth: 'xs',
          fullWidth: true,
          containerClasses: 'p-4',
          showCloseButton: true,
          disableBackdropClickClose: true,
          disableEscapeKeyDownClose: true,
          dialogContent: (
            <Popup
              useNewResume={(props) => {
                close?.();
                this.addNewResume(props);
              }}
              oldResponse={checkDuplicate[0]}
              jobId={jobDetails.jobId}
              jobTitle={jobDetails.jobTitle}
              email={email}
              fileName={fileName}
              candidateDetailsFormData={formData}
            />
          ),
        });
      }
    } catch (e) {
      await confirmWrapper('Something went wrong', {
        hideSecondaryBtn: true,
        variant: 'danger',
      });
    }
  };

  addNewResume = (props: { confirmationPopupClose: (() => void) | undefined, res?: any }) => {
    const { confirmationPopupClose: close, res } = props;
    this.setState({ parseResponse: res, useNewResume: true }, () => {
      if (close) close();
      this.showPopup(res);
    });
  };

  onDocumentView = async (doc: any): Promise<void> => {
    await confirmWrapper('', {
      variant: '',
      hidePrimaryBtn: true,
      hideSecondaryBtn: true,
      maxWidth: 'md',
      fullWidth: true,
      containerClasses: 'pt-10',
      showCloseButton: true,
      disableBackdropClickClose: true,
      disableEscapeKeyDownClose: true,
      dialogContent: (
        <div>
          <DocViewer
            style={{ width: 800, height: 800 }}
            documents={[{
              uri: doc.presignedUrl || '',
              fileType: getContentType(doc.documentURL || '', doc.documentURL || ''),
            }]}
            pluginRenderers={DocViewerRenderers}
          />
        </div>
      ),
    });
  };

  getProps = (): ViewJobViewRendererProps => {
    const {
      loading,
      jobDetails,
      candidatesLoading,
      candidatesList,
      matchingResumeList,
      payTypes,
      workAuthorizations,
      resumeSources,
      fetchingJobDetails,
      assignedToAll,
      tabValue,
    } = this.state;
    const { router } = this.props;
    const { id: jobId } = router?.params ?? {};

    return {
      fetchingJobDetails,
      loading,
      jobId,
      jobDetails,
      candidatesLoading,
      candidatesList,
      matchingResumeList,
      payTypes,
      workAuthorizations,
      resumeSources,
      assignedToAll,
      tabValue,
      handleChangeTabValue: this.handleChangeTabValue,
      getCandidatesForJob: this.getCandidatesForJob,
      getMatchingResumes: this.getMatchingResumes,
      updateJobDetails: this.updateJobDetails,
      updateOthersTab: this.updateOthersTab,
      updateJobLocations: this.updateJobLocations,
      updateSkills: this.updateSkills,
      updateJobRecruiters: this.updateJobRecruiters,
      updateJobDescription: this.updateJobDescription,
      addJobNotes: this.addJobNotes,
      updateJobNotes: this.updateJobNotes,
      showCandidateDetailsForm: this.showCandidateDetailsForm,
      onClose: this.onClose,
      setAssignedToAll: this.setAssignedToAll,
      onDocumentView: this.onDocumentView,
    };
  };

  render() {
    const viewProps: ViewJobViewRendererProps = this.getProps();

    return (
      <ViewRenderer {...viewProps} />
    );
  }
}

const mapStateToProps = (reduxProps: AppRootState) => ({
  reduxProps,
});

const mapDispatchToProps = (dispatch: any) => ({
  updateReduxTab: (tab: TabInfo) => dispatch(updateTab(tab)),
});

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(withRouter(ViewJob));
